/** Navigation du back-office : 4 groupes, 18 entrées (spec § 3.2). */
import { can, type Permission, type StaffRole } from '@johnsaks/core'

export interface NavEntry {
  to: string
  label: string
  badge?: number
  /** Permission minimale pour afficher l’entrée. Absente = visible si authentifié. */
  permission?: Permission
}

export interface NavGroup {
  titre: string
  entrees: NavEntry[]
}

export const NAV: NavGroup[] = [
  {
    titre: 'Pilotage',
    entrees: [
      { to: '/', label: 'Vue d’ensemble', permission: 'orders.read' },
      { to: '/rapports', label: 'Rapports', permission: 'orders.read' },
      { to: '/journal', label: 'Journal d’activité', permission: 'audit.read' },
    ],
  },
  {
    titre: 'Ventes',
    entrees: [
      { to: '/commandes', label: 'Commandes', permission: 'orders.read' },
      { to: '/retours', label: 'Retours', permission: 'orders.read' },
      { to: '/paniers-abandonnes', label: 'Paniers abandonnés', permission: 'customers.read' },
      { to: '/codes-promo', label: 'Codes promo', permission: 'orders.discount' },
      { to: '/paiements', label: 'Paiements', permission: 'payments.read' },
    ],
  },
  {
    titre: 'Catalogue',
    entrees: [
      { to: '/produits', label: 'Produits', permission: 'products.read' },
      { to: '/stocks', label: 'Stocks', permission: 'inventory.write' },
      { to: '/receptions', label: 'Réceptions', permission: 'purchasing.receive' },
      { to: '/avis', label: 'Avis', permission: 'reviews.moderate' },
    ],
  },
  {
    titre: 'Clients et réglages',
    entrees: [
      { to: '/clients', label: 'Clients', permission: 'customers.read' },
      { to: '/livraisons', label: 'Livraisons', permission: 'delivery.write' },
      { to: '/utilisateurs', label: 'Utilisateurs', permission: 'staff.manage' },
      { to: '/modeles', label: 'Modèles de messages', permission: 'templates.write' },
      { to: '/pages-legales', label: 'Pages légales', permission: 'legal.publish' },
      { to: '/reglages', label: 'Réglages', permission: 'settings.write' },
    ],
  },
]

export function filterNav(role: StaffRole | null | undefined): NavGroup[] {
  if (!role) return []
  return NAV.map((g) => ({
    ...g,
    entrees: g.entrees.filter((e) => !e.permission || can(role, e.permission)),
  })).filter((g) => g.entrees.length > 0)
}
